import React from 'react'
import { Navigate, Route, Routes } from 'react-router-dom'

const Vista_DetailsPage = React.lazy(
  () => import('@/features/equipamentos/features/vista/pages/detalhes'),
)
const Vista_HeaderOutlet = React.lazy(
  () =>
    import('@/features/equipamentos/features/vista/layouts/vista-header-outlet'),
)

export default function Component() {
  return (
    <Routes>
      <Route index element={<Navigate to="/app/entity/equipamentos" />} />
      <Route path=":vistaId" element={<Vista_HeaderOutlet />}>
        <Route path="detalhes" element={<Vista_DetailsPage />} />
      </Route>
    </Routes>
  )
}
